module.exports = __webpack_public_path__ + "media/hyper/images/products/product-5-b01cad8f68620feceb9e063e92cb19b8.jpg";